export const APP_LOADED_RECORDED = 'APP_LOADED_RECORDED';

export const setHasReportedAppLoaded = () => ({
  type: APP_LOADED_RECORDED,
});
